"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Function to return nothing
 * @returns {void}
 */
var noop = function () { };
exports.default = noop;
